<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
  <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub2}}</h1>
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub3}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="permit1">
      <input type="checkbox" class="custom-control-input mgntp10" id="permit1" value="Yes"
        name="permissions" [(ngModel)]="hgPermission.permission1" (click)="getPermission($event)" />
      <label class="custom-control-label font20" for="permit1">Yes</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="permit2">
      <input type="checkbox" class="custom-control-input mgntp10" id="permit2" value="No, not yet"
        name="permissions" [(ngModel)]="hgPermission.permission2" (click)="getPermission($event)" />
      <label class="custom-control-label font20" for="permit2">No, not yet</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="permit3">
      <input type="checkbox" class="custom-control-input mgntp10" id="permit3" value="Not necessary" name="permissions"
        [(ngModel)]="hgPermission.permission3" (click)="getPermission($event)" />
      <label class="custom-control-label font20" for="permit3">Not necessary</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="permit4">
      <input type="checkbox" class="custom-control-input mgntp10" id="permit4" value="I need to get a permit?"
        name="permissions" [(ngModel)]="hgPermission.permission4" (click)="getPermission($event)" />
      <label class="custom-control-label font20" for="permit4">I need to get a permit?</label>
    </label>
  </div>
  <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
    (click)="next();">Next</button>
  <div class="mt-5" *ngIf="showTip">
    <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr text-center">
      <img src="assets/images/flash.png" class="mb-1" />
      <p class="text-center tiphead">{{tipHead}}</p>
      <p class="text-center tipmes">{{tip}}</p>
    </div>
  </div>
</div>
<div class="container mobileview mt-1 px-0" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label class="custom-control custom-checkbox chkbox mb-2" for="permit1_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="permit1_mob" value="Yes"
          name="permissions" [(ngModel)]="hgPermission.permission1" (click)="getPermission($event)" />
        <label class="custom-control-label font20" for="permit1_mob">Yes</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="permit2_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="permit2_mob" value="No, not yet"
          name="permissions" [(ngModel)]="hgPermission.permission2" (click)="getPermission($event)" />
        <label class="custom-control-label font20" for="permit2_mob">No, not yet</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="permit3_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="permit3_mob" value="Not necessary"
          name="permissions" [(ngModel)]="hgPermission.permission3" (click)="getPermission($event)" />
        <label class="custom-control-label font20" for="permit3_mob">Not necessary</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="permit4_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="permit4_mob" value="I need to get a permit?"
          name="permissions" [(ngModel)]="hgPermission.permission4" (click)="getPermission($event)" />
        <label class="custom-control-label font20" for="permit4_mob">I need to get a permit?</label>
      </label>
    </div>
    <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right">
        <h1 class="ansMob text-right">{{permission}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 mb-3 mt-3" *ngIf="showTip">
    <div class="m-auto blockbg boxclr">
      <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
      <p class="text-center tiphead">{{tipHead}}</p>
      <p class="text-center tipmes">{{tip}}</p>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
            <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div>
</div>